import { EditorContent } from '@tiptap/react'
import { useRef } from 'react'
import { LinkMenu } from '../menus'
import { ContentItemMenu } from '../menus/ContentItemMenu'
import { TextMenu } from '../menus/TextMenu'
import { type TiptapProps } from './types'

export const Customizer = ({ editor }: TiptapProps) => {
	const menuContainerRef = useRef(null)

	return (
		<div
			ref={menuContainerRef}
			className={`w-full transition-opacity duration-200`}
		>
			{editor && (
				<div className="relative flex flex-col">
					<EditorContent
						editor={editor}
						className="flex-1 overflow-y-visible"
					/>
					<ContentItemMenu editor={editor} />
					<LinkMenu editor={editor} appendTo={menuContainerRef} />
					<TextMenu editor={editor} />
				</div>
			)}
		</div>
	)
}

export default Customizer
